/**
 * SOLFIE — Reforço de conversão no cart drawer nativo do tema.
 *
 * O tema usa o cart-drawer-component do Horizon. Este script injeta, sem
 * alterar o tema base:
 *
 *   1. barra de progresso de frete grátis (com quanto falta)
 *   2. cross-sell ("combina com") carregado via product-recommendations
 *   3. selo de parcelamento
 *
 * Reage a:
 *   - abertura do drawer (atributo `open` / `aria-hidden` do cart-drawer)
 *   - eventos cart:add, cart:update, cart:refresh, cart:updated
 *   - shopify:section:load (editor de tema)
 *
 * Configuração via data-attributes em #solfie-cart-config (layout/theme.liquid).
 */
(function () {
  'use strict';

  var cfg = document.getElementById('solfie-cart-config');
  if (!cfg) return;

  var LIMITE_FRETE = parseInt(cfg.dataset.freeShipping, 10) || 99900;
  var INS_MAX = parseInt(cfg.dataset.installments, 10) || 10;
  var MOSTRAR_CROSS = cfg.dataset.crossSell !== 'false';
  var MOSTRAR_FRETE = cfg.dataset.freeShippingEnabled !== 'false';
  var CROSS_QTD = parseInt(cfg.dataset.crossSellCount, 10) || 4;
  var CROSS_TITULO = cfg.dataset.crossSellTitle || 'Combina com seu carrinho';
  var TEXTO_FALTA = cfg.dataset.textRemaining || 'Faltam {valor} para frete grátis';
  var TEXTO_OK = cfg.dataset.textUnlocked || 'Você ganhou frete grátis!';
  var TEXTO_SEGURO = cfg.dataset.textSecure || 'Compra 100% segura';

  var MOEDA = (cfg.dataset.currency || 'BRL');
  var LOCALE = (cfg.dataset.locale || 'pt-BR');

  function brl(centavos) {
    try {
      return (centavos / 100).toLocaleString(LOCALE, { style: 'currency', currency: MOEDA });
    } catch (e) {
      return 'R$ ' + (centavos / 100).toFixed(2).replace('.', ',');
    }
  }

  function dinheiroDoTema(valor) {
    /* usa o formatador do tema quando disponivel (Shopify.formatMoney) */
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function' && cfg.dataset.moneyFormat) {
      try { return window.Shopify.formatMoney(valor, cfg.dataset.moneyFormat); } catch (e) {}
    }
    return brl(valor);
  }

  /* ---------- encontra o drawer ---------- */
  function acharDrawer() {
    return document.querySelector('cart-drawer-component .cart-drawer, .cart-drawer');
  }

  function acharConteudo(drawer) {
    return drawer.querySelector('.cart-drawer__content, .cart-drawer__body, [ref="cartDrawerContent"]') || drawer;
  }

  /* ---------- 1. barra de frete grátis ---------- */
  function atualizarFrete(drawer, cart) {
    /* carrinho vazio: nada de barra de frete nem parcelamento (o drawer mostra
       "O carrinho está vazio") */
    var boxVazia = drawer.querySelector('[data-solfie="frete"]');
    if (!cart.item_count) {
      if (boxVazia) boxVazia.remove();
      return;
    }

    var total = cart.total_price || 0;

    /* A barra de FRETE agora e unica: a mesma `solfie-fb` da PDP e da pagina
       /cart, injetada por assets/solfie-frete-bar.js e lendo o mesmo valor do
       painel. Aqui fica so o selo de seguranca + o parcelamento. */
    var box = drawer.querySelector('[data-solfie="frete"]');
    if (!box) {
      box = document.createElement('div');
      box.className = 'solfie-cd-frete solfie-cd-frete--extra';
      box.setAttribute('data-solfie', 'frete');
      box.innerHTML =
        '<p class="solfie-cd-frete__extra">' +
          '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><path d="M9 12l2 2 4-4"/></svg>' +
          '<span>' + TEXTO_SEGURO + '</span>' +
        '</p>';

      /* ULTIMO filho da lista de itens: mesmo lugar seguro das outras injecoes
         (o morph do tema casa filhos por POSICAO) */
      var destino = drawer.querySelector('.cart-drawer__items') || acharConteudo(drawer);
      destino.appendChild(box);
    }

    /* parcelamento */
    var parcelas = Math.max(1, Math.min(INS_MAX, Math.floor(total / 1000)));
    var extra = box.querySelector('.solfie-cd-frete__extra span');
    if (extra && total > 0) {
      extra.textContent = 'ou ' + parcelas + 'x de ' + dinheiroDoTema(Math.round(total / parcelas)) + ' sem juros';
    }
  }

  /* ---------- 3. barra de progresso de DESCONTO ---------- */
  /* Valores do painel Solfie (fallback: R$ 999 / 10%). Mostra quanto falta para
     o cliente atingir o valor minimo que libera o desconto. */
  function atualizarDesconto(drawer, cart) {
    var ativo = cfg.dataset.descontoAtivo !== 'false';
    var meta = parseInt(cfg.dataset.descontoMeta, 10) || 0;
    var pctOff = parseFloat(cfg.dataset.descontoPct) || 0;
    var txt = cfg.dataset.descontoTexto || 'Faltam __VALOR__ para ganhar __PCT__% OFF';
    var txtOk = cfg.dataset.descontoTextoOk || 'Você liberou __PCT__% OFF nesta compra!';

    var existente = drawer.querySelector('[data-solfie="desconto"]');

    if (!ativo || !meta || !pctOff || !cart.item_count) {
      if (existente) existente.remove();
      return;
    }

    var alvo = meta * 100;
    var total = cart.total_price || 0;
    var falta = alvo - total;
    var pct = Math.max(0, Math.min(100, Math.round((total / alvo) * 100)));

    var box = existente;
    if (!box) {
      box = document.createElement('div');
      box.className = 'solfie-cd-desc';
      box.setAttribute('data-solfie', 'desconto');
      box.innerHTML =
        '<p class="solfie-cd-desc__texto" data-solfie="desc-texto"></p>' +
        '<div class="solfie-cd-desc__trilha" role="progressbar" aria-valuemin="0" aria-valuemax="100">' +
          '<span class="solfie-cd-desc__fill"></span>' +
        '</div>';

      /* ULTIMO filho da lista de itens: o mesmo lugar seguro do widget de
         addons (o morph do tema casa filhos por POSICAO e fundiria um no
         injetado como irmao do resumo) */
      var destino = drawer.querySelector('.cart-drawer__items') || acharConteudo(drawer);
      destino.appendChild(box);
    }

    var texto = box.querySelector('[data-solfie="desc-texto"]');
    var fill = box.querySelector('.solfie-cd-desc__fill');
    var trilha = box.querySelector('.solfie-cd-desc__trilha');

    /* aceita os dois formatos de placeholder: __VALOR__ (usado no layout, sem
       chaves porque o Liquid nao aceita { } dentro de {{ }}) e {valor} */
    function troca(t, valorTxt, pctTxt) {
      return String(t)
        .replace('__VALOR__', valorTxt).replace('{valor}', valorTxt)
        .replace('__PCT__', pctTxt).replace('{pct}', pctTxt);
    }

    if (falta > 0) {
      box.classList.remove('is-ok');
      texto.innerHTML = troca(txt, '<strong>' + dinheiroDoTema(falta) + '</strong>', pctOff);
    } else {
      box.classList.add('is-ok');
      texto.innerHTML = '<strong>' + troca(txtOk, '', pctOff) + '</strong>';
    }
    if (fill) fill.style.width = pct + '%';
    if (trilha) trilha.setAttribute('aria-valuenow', String(pct));
  }

  /* ---------- 3b. CTAs do drawer (caminho para o Yampi) ---------- */
  /*
   * O `#checkout` do tema fica oculto (`#checkout { display: none }` no
   * cart-summary) porque quem assume o checkout e o Yampi — e ele so age na
   * pagina /cart. Os dois CTAs do drawer sao `<a>` puros apontando para /cart:
   * funcionam mesmo se o JS falhar, deixam o caminho explicito para a cliente
   * (antes o drawer ficava sem CTA principal) e levam ao handshake do Yampi,
   * que mantem PIX/boleto/parcelamento.
   */
  var TEXTO_SWIPE = 'Deslize para finalizar';
  var SETA_KNOB =
    '<svg width="7" height="12" viewBox="0 0 7 12" fill="none" aria-hidden="true">' +
    '<path d="M1 1l5 5-5 5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var TEXTO_CARRINHO = 'Ir para o carrinho';
  var SETA_CTA =
    '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"' +
    ' stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
    '<path d="M9 5l7 7-7 7"/></svg>';

  /* Painel do CTA-assinatura (`snippets/solfie-cta.liquid`): o painel claro que
     expande no hover revelando o rastro de chevrons pontilhados. Em string
     porque o drawer e montado por JS, nao por Liquid. */
  function painelCta() {
    var pontos = '';
    for (var i = 0; i < 5; i++) pontos += '<span class="solfie-cta__dots"></span>';
    return (
      '<span class="solfie-cta__panel" aria-hidden="true">' +
        '<span class="solfie-cta__dots solfie-cta__dots--solo"></span>' +
        '<span class="solfie-cta__trail">' + pontos + '</span>' +
      '</span>'
    );
  }

  function criarCta(papel, rotulo, comSeta) {
    var link = document.createElement('a');
    var ehAssinatura = papel === 'primary';
    link.className =
      'solfie-ir-cart solfie-ir-cart--' + papel +
      (ehAssinatura ? ' solfie-cta solfie-cta--md is-destaque' : '');
    link.href = '/cart';
    link.setAttribute('data-solfie', 'cta-' + papel);
    link.innerHTML =
      (ehAssinatura ? painelCta() : '') +
      '<span class="solfie-ir-cart__label' + (ehAssinatura ? ' solfie-cta__label' : '') + '">' +
        rotulo +
      '</span>' +
      (comSeta ? SETA_CTA : '');
    return link;
  }

  /* Swipe to Confirm (assets/solfie-swipe.js): substitui o CTA primario do
     drawer. O destino continua /cart (handshake do Yampi), mas finalizar exige
     o gesto — no celular, encostar sem querer nao fecha mais a compra. */
  function criarSwipe() {
    var el = document.createElement('div');
    el.className = 'solfie-swipe solfie-swipe--drawer';
    el.setAttribute('data-solfie-swipe', '');
    el.setAttribute('data-href', '/cart');
    el.setAttribute('data-label', TEXTO_SWIPE);
    el.setAttribute('data-done', 'Abrindo checkout…');
    el.setAttribute('data-loader', '.yampi-loader');
    el.setAttribute('role', 'slider');
    el.setAttribute('tabindex', '0');
    el.setAttribute('aria-label', TEXTO_SWIPE);
    el.setAttribute('aria-valuemin', '0');
    el.setAttribute('aria-valuemax', '100');
    el.setAttribute('aria-valuenow', '0');
    el.setAttribute('aria-valuetext', 'Arraste até o fim para finalizar');
    el.innerHTML =
      '<span class="solfie-swipe__fill" aria-hidden="true"></span>' +
      '<span class="solfie-swipe__label">' + TEXTO_SWIPE + '</span>' +
      '<span class="solfie-swipe__knob" aria-hidden="true">' +
        '<span class="solfie-swipe__chevrons">' + SETA_KNOB + SETA_KNOB + SETA_KNOB + '</span>' +
        '<svg class="solfie-swipe__check" viewBox="0 0 24 24" fill="none" aria-hidden="true">' +
          '<path d="M5 13l4 4L19 7" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
      '</span>';
    return el;
  }

  function atualizarIrCarrinho(drawer, cart) {
    var ctas = drawer.querySelector('.cart__ctas');
    var existentes = [].slice.call(drawer.querySelectorAll('.solfie-ir-cart'));

    if (!ctas || !cart.item_count) {
      existentes.forEach(function (el) { el.remove(); });
      var sw = drawer.querySelector('.solfie-swipe--drawer');
      if (sw) sw.remove();
      return;
    }

    /* descarta o CTA antigo (sem papel) de uma pagina em cache */
    existentes.forEach(function (el) {
      if (!el.classList.contains('solfie-ir-cart--primary') &&
          !el.classList.contains('solfie-ir-cart--secondary')) {
        el.remove();
      }
    });

    /* o CTA primario do link-assinatura saiu: quem finaliza agora e o swipe
       (o link continua existindo para quem chega com pagina em cache) */
    drawer.querySelectorAll('.solfie-ir-cart--primary').forEach(function (el) { el.remove(); });

    var secundario = drawer.querySelector('.solfie-ir-cart--secondary') ||
      criarCta('secondary', TEXTO_CARRINHO, true);
    var swipe = ctas.querySelector('.solfie-swipe') || criarSwipe();

    /* o Yampi tambem injeta no `.cart__ctas`: garante a ordem final
       (checkout oculto, swipe, secundario) sem recriar os nos */
    if (secundario.parentNode !== ctas) ctas.appendChild(secundario);
    if (swipe.parentNode !== ctas || swipe.nextElementSibling !== secundario) {
      ctas.insertBefore(swipe, secundario);
    }

    /* o card pode ter sido injetado depois do boot do solfie-swipe.js */
    if (window.SolfieSwipe && window.SolfieSwipe.iniciar) window.SolfieSwipe.iniciar();
  }

  /* ---------- 2. cross-sell ---------- */
  var crossCache = {};

  function renderCross(drawer, cart) {
    if (!MOSTRAR_CROSS) return;

    var box = drawer.querySelector('[data-solfie="cross"]');
    if (!box) {
      box = document.createElement('div');
      box.className = 'solfie-cd-cross';
      box.setAttribute('data-solfie', 'cross');
      box.innerHTML =
        '<h3 class="solfie-cd-cross__title">' + CROSS_TITULO + '</h3>' +
        '<div class="solfie-cd-cross__list" data-solfie="cross-list"></div>';
      var conteudo = acharConteudo(drawer);
      conteudo.appendChild(box);
    }

    var lista = box.querySelector('[data-solfie="cross-list"]');
    var noCarrinho = (cart.items || []).map(function (i) { return String(i.product_id); });
    var primeiro = cart.items && cart.items[0];
    if (!primeiro) { box.hidden = true; return; }

    var chave = String(primeiro.product_id);
    if (crossCache[chave]) {
      pintarCross(lista, crossCache[chave], noCarrinho);
      return;
    }

    fetch('/recommendations/products.json?product_id=' + chave + '&limit=' + (CROSS_QTD + 2) + '&intent=related')
      .then(function (r) { return r.json(); })
      .then(function (d) {
        crossCache[chave] = d.products || [];
        pintarCross(lista, crossCache[chave], noCarrinho);
      })
      .catch(function () { box.hidden = true; });
  }

  function pintarCross(lista, produtos, noCarrinho) {
    var uteis = produtos.filter(function (p) {
      return p.available && noCarrinho.indexOf(String(p.id)) === -1;
    }).slice(0, CROSS_QTD);

    if (!uteis.length) {
      lista.closest('[data-solfie="cross"]').hidden = true;
      return;
    }

    lista.innerHTML = uteis.map(function (p) {
      var img = p.featured_image
        ? p.featured_image.replace(/(\.[a-z]+)(\?|$)/i, '_200x$1$2')
        : '';
      var variante = p.variants && p.variants[0] ? p.variants[0].id : '';
      return '' +
        '<div class="solfie-cd-cross__item">' +
          (img ? '<img class="solfie-cd-cross__img" src="' + img + '" alt="" width="56" height="70" loading="lazy" decoding="async">' : '<span class="solfie-cd-cross__img"></span>') +
          '<div class="solfie-cd-cross__info">' +
            '<a class="solfie-cd-cross__nome" href="' + p.url + '">' + p.title + '</a>' +
            '<span class="solfie-cd-cross__preco">' + brl(p.price) + '</span>' +
          '</div>' +
          '<button type="button" class="solfie-cd-cross__add" data-variant="' + variante + '" aria-label="Adicionar ' + p.title + '">' +
            '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg>' +
          '</button>' +
        '</div>';
    }).join('');

    lista.querySelectorAll('[data-variant]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.classList.contains('is-loading')) return;
        btn.classList.add('is-loading');
        btn.innerHTML = '<span class="solfie-cd-cross__spin" aria-hidden="true"></span>';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(btn.dataset.variant), quantity: 1 }] })
        })
          .then(function (r) { if (!r.ok) throw new Error('falhou'); return r.json(); })
          .then(function () {
            btn.classList.remove('is-loading');
            btn.classList.add('is-done');
            btn.innerHTML = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6L9 17l-5-5"/></svg>';
            /* recarrega o carrinho e o proprio cross-sell */
            atualizar();
            /* e avisa o tema: sem isso a LISTA de itens do drawer nao mudava */
            avisarTema();
            setTimeout(function () {
              btn.classList.remove('is-done');
              btn.innerHTML = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg>';
            }, 1800);
          })
          .catch(function () {
            btn.classList.remove('is-loading');
            btn.innerHTML = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M18 6 6 18M6 6l12 12"/></svg>';
            setTimeout(function () {
              btn.innerHTML = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg>';
            }, 1800);
          });
      });
    });
  }

  /* ---------- ciclo ---------- */
  var ultimoTotal = -1;

  function atualizar() {
    var drawer = acharDrawer();
    if (!drawer) return;

    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var mudou = cart.total_price !== ultimoTotal;
        ultimoTotal = cart.total_price;

        if (cart.item_count > 0) {
          atualizarFrete(drawer, cart);
      atualizarDesconto(drawer, cart);
      atualizarIrCarrinho(drawer, cart);
          renderCross(drawer, cart);
        } else {
          var f = drawer.querySelector('[data-solfie="frete"]');
          var c = drawer.querySelector('[data-solfie="cross"]');
          if (f) f.remove();
          if (c) c.remove();
        }
      })
      .catch(function () {});
  }

  /* observa a abertura do drawer */
  var alvo = document.querySelector('cart-drawer-component') || document.body;

  if ('MutationObserver' in window) {
    var debounce = null;
    new MutationObserver(function (mut) {
      var abriu = mut.some(function (m) {
        if (m.type === 'attributes') {
          var el = m.target;
          var open = el.hasAttribute('open') ||
                     el.getAttribute('aria-hidden') === 'false' ||
                     (el.classList && el.classList.contains('is-open'));
          return !!open;
        }
        return false;
      });
      if (!abriu) return;
      clearTimeout(debounce);
      debounce = setTimeout(atualizar, 120);
    }).observe(alvo, {
      attributes: true,
      attributeFilter: ['open', 'aria-hidden', 'class'],
      subtree: true
    });
  }

  /* eventos do tema e de apps */
  ['cart:add', 'cart:update', 'cart:refresh', 'cart:updated', 'cart:open'].forEach(function (ev) {
    document.addEventListener(ev, function () { setTimeout(atualizar, 140); });
  });

  /* ---------- 5. ponte para o carrinho do TEMA ---------- */
  /*
   * Vários fluxos que adicionam com fetch próprio (a PDP customizada, os cards
   * da home, o "Complete seu kit", as duplas e o cart-recommendations.js do
   * tema) avisam o carrinho com `cart:update`/`cart:refresh` SEM o `detail` que
   * o tema (Horizon) lê: `event.detail.data.itemCount` e
   * `event.detail.data.sections`. Com detail nulo os listeners do tema estouram
   * `TypeError: Cannot read properties of null (reading 'data')` ANTES de pedir
   * a seção, então o drawer fica com o HTML do load da página (vazio, com o
   * subtotal/frete certos). Aqui a gente lê /cart.js e reemite o evento no
   * formato do tema — o drawer se re-renderiza sozinho.
   */
  var EVENTO_TEMA = 'cart:update';
  var ponteTimer = null;
  var ponteUltimoBom = 0;

  function avisoDoTemaOk(ev) {
    var d = ev && ev.detail;
    return !!(d && d.data && typeof d.data.itemCount === 'number');
  }

  function avisarTema() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.dispatchEvent(new CustomEvent(EVENTO_TEMA, {
          bubbles: true,
          detail: {
            resource: cart,
            sourceId: 'solfie-ponte',
            data: { source: 'solfie-ponte', itemCount: cart.item_count, didError: false }
          }
        }));
      })
      .catch(function () {});
  }

  ['cart:add', 'cart:update', 'cart:refresh', 'cart:updated'].forEach(function (ev) {
    document.addEventListener(ev, function (e) {
      if (avisoDoTemaOk(e)) {
        /* o tema já foi avisado direito: não duplica o trabalho */
        ponteUltimoBom = Date.now();
        return;
      }
      if (Date.now() - ponteUltimoBom < 400) return;
      clearTimeout(ponteTimer);
      ponteTimer = setTimeout(avisarTema, 80);
    });
  });

  /* editor de tema */
  /* ---------- 4. checkout Yampi a partir do drawer ---------- */
  /*
   * O snippet do Yampi so age na pagina /cart: ele envia o carrinho para a API
   * e usa `checkout_direct_url` (as vezes limpando o carrinho e redirecionando).
   * Aqui, o botao de finalizar DENTRO do drawer leva para /cart para esse
   * handshake acontecer — sem isso a cliente finaliza no checkout da Shopify e
   * perde PIX/boleto/parcelamento do Yampi.
   */
  document.addEventListener(
    'click',
    function (e) {
      var btn = e.target.closest(
        'a[href*="/checkout"], button[name="checkout"], input[name="checkout"]'
      );
      if (!btn) return;
      /* so no drawer do tema (na pagina /cart quem cuida disso e o Yampi) */
      if (!btn.closest('cart-drawer-component')) return;
      if (e.defaultPrevented) return;

      e.preventDefault();
      e.stopPropagation();

      var loader = document.querySelector('.yampi-loader');
      if (loader) loader.style.display = 'block';

      window.location.href = '/cart';
    },
    true
  );

  document.addEventListener('shopify:section:load', function () { setTimeout(atualizar, 200); });

  /* primeira carga: se o drawer ja existir com itens */
  if (document.readyState === 'complete') { setTimeout(atualizar, 400); }
  else { window.addEventListener('load', function () { setTimeout(atualizar, 400); }); }
})();
